import styled from '@emotion/styled';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { CardImage } from 'components/common/ui/CardImage';

export const Container = styled.div`
  border-bottom: 1px solid ${props => props.theme.COLORSV3.BLACK_030};
  position: relative;
`;

export const Tags = styled.div`
  position: absolute;
  top: 16px;
  left: 12px;
`;

export const Intro = styled.div`
  margin: 40px 0px;
  padding: 0 20px;

  ${props => props.theme.MEDIA_QUERY.EXCLUDE_MOBILE} {
    text-align: center;
  }
`;

export const Title = styled.h1`
  margin: 12px auto 0;

  ${props => props.theme.MEDIA_QUERY.EXCLUDE_MOBILE} {
    font-size: ${props => props.theme.FONTS.FONT_SIZE_SEMI_HUGE};
    width: 530px;
  }

  ${props => props.theme.MEDIA_QUERY.DESKTOP} {
    width: auto;
  }
`;

export const SubTitle = styled.h2`
  font-size: ${props => props.theme.FONTS.FONT_SIZE_SMALL};
  line-height: 24px;

  ${props => props.theme.MEDIA_QUERY.EXCLUDE_MOBILE} {
    font-size: ${props => props.theme.FONTS.FONT_SIZE_REGULAR};
  }
`;

export const Description = styled.p`
  margin: 24px 0 0;
  font-size: 18px;
  line-height: 25px;

  ${props => props.theme.MEDIA_QUERY.EXCLUDE_MOBILE} {
    font-size: ${props => props.theme.FONTS.FONT_SIZE_REGULAR};
    line-height: 32px;
  }

  ${props => props.theme.MEDIA_QUERY.DESKTOP_XL} {
    font-size: ${props => props.theme.FONTS.FONT_SIZE_LARGE};
  }
`;

export const CarouselContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0 40px;
`;

export const CarouselScrollContainer = styled.div`
  overflow-x: auto;
  display: flex;
`;

export const CardContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 10px;
  min-width: 200px;
  position: relative;
  width: 200px;

  :first-of-type {
    margin-left: 20px;
  }

  :last-of-type {
    margin-right: 20px;
  }

  ${props => props.theme.MEDIA_QUERY.DESKTOP} {
    margin: 20px;
    min-width: 220px;
    width: 220px;

    :first-of-type {
      margin-left: 40px;
    }
    :last-of-type {
      margin-right: 40px;
    }
  }
`;

export const StyledCardImage = styled(CardImage)`
  width: 100%;
  display: block;
  border-radius: 16px;
`;

export const Actions = styled.div`
  width: 100%;
  position: absolute;
  bottom: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonV3Borderless = styled(ButtonV3)`
  border: none;
`;
